import {createAsyncThunk} from '@reduxjs/toolkit';
import type {
  FetchCampaignRecipientInsightsArg,
  FetchCampaignRecipientInsightsResponse,
  FetchInvalidCampaignRecipientEmailsResponse,
  FetchInvalidCampaignRecipientEmailsArg,
  InitEmailMarketingCampaignPerformanceArg,
  InitEmailMarketingCampaignPerformanceResponse,
  RemoveAllInvalidCampaignEmailsArg,
  RemoveInvalidEmailsArg,
} from './email-marketing-campaign-performance.types';
import {INVALID_RECIPIENTS_FETCH_LIMIT, RecipientInsightsFilter} from './email-marketing-campaign-performance.types';

const REMOVE_ALL_INVALID_EMAILS_FLAG = 1;

export const initEmailMarketingCampaignPerformance = createAsyncThunk(
  'initEmailMarketingCampaignPerformance',
  async (data: InitEmailMarketingCampaignPerformanceArg): Promise<InitEmailMarketingCampaignPerformanceResponse> => {
    return (await window.PMW.readLocal('emailmarketing/initEmailMarketingCampaignPerformance', data)) as InitEmailMarketingCampaignPerformanceResponse;
  }
);

export const fetchCampaignRecipientInsights = createAsyncThunk(
  'fetchCampaignRecipientInsights',
  async (data: FetchCampaignRecipientInsightsArg): Promise<FetchCampaignRecipientInsightsResponse> => {
    return (await window.PMW.readLocal('emailmarketing/getCampaignRecipientInsights', data)) as FetchCampaignRecipientInsightsResponse;
  }
);

export const fetchInvalidCampaignRecipientEmails = createAsyncThunk(
  'fetchInvalidCampaignRecipientEmails',
  async (data: FetchInvalidCampaignRecipientEmailsArg): Promise<FetchInvalidCampaignRecipientEmailsResponse> => {
    return (await window.PMW.readLocal('emailmarketing/getCampaignRecipientInsights', {
      campaignId: data.campaignId,
      limit: INVALID_RECIPIENTS_FETCH_LIMIT,
      offset: data.offset,
      filter: RecipientInsightsFilter.INVALID,
    })) as FetchInvalidCampaignRecipientEmailsResponse;
  }
);

export const removeInvalidEmailsForCampaign = createAsyncThunk(
  'removeInvalidEmailsForCampaign',
  async (data: RemoveInvalidEmailsArg): Promise<void> => {
    await window.PMW.writeLocal('emailmarketing/removeInvalidEmailsForCampaign', {id: data.id, emails: JSON.stringify(data.emails)});
  }
);

export const removeAllInvalidEmailsForCampaign = createAsyncThunk(
  'removeAllInvalidEmailsForCampaign',
  async (data: RemoveAllInvalidCampaignEmailsArg): Promise<void> => {
    await window.PMW.writeLocal('emailmarketing/removeInvalidEmailsForCampaign', {
      id: data.id,
      removeAll: REMOVE_ALL_INVALID_EMAILS_FLAG,
      excludedEmails: JSON.stringify(data.excludedEmails),
    });
  }
);

export const removeInvalidEmailsForMailingList = createAsyncThunk(
  'removeInvalidEmailsForMailingList',
  async (data: RemoveInvalidEmailsArg): Promise<void> => {
    await window.PMW.writeLocal('emailmarketing/removeInvalidEmailsForMailingList', {id: data.id, emails: JSON.stringify(data.emails)});
  }
);
